import { Edit2 } from "lucide-react";

import { ClienteDTO } from "@/types/cliente.type";
import { useClienteEditForm } from "@/hooks/clientes/use-cliente-form";
import { ClienteFormDialog } from "./ClienteFormDialog";

interface ClienteEditFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clienteToEdit: ClienteDTO | null;
  onSuccess: (dadosAtualizados: Partial<ClienteDTO>) => void;
}

export function ClienteEditFormDialog({
  open,
  onOpenChange,
  clienteToEdit,
  onSuccess,
}: ClienteEditFormDialogProps) {
  const { form, isSubmitting, onSubmit } = useClienteEditForm(
    open,
    onOpenChange,
    clienteToEdit,
    onSuccess,
  );

  return (
    <ClienteFormDialog
      open={open}
      onOpenChange={onOpenChange}
      form={form}
      isSubmitting={isSubmitting}
      onSubmit={onSubmit}
      icon={<Edit2 className="h-5 w-5" />}
      title="Editar cliente"
      subtitle={
        <>
          Alterando <span className="font-semibold text-foreground">{clienteToEdit?.nome}</span>
        </>
      }
      submitLabel="Salvar alterações"
      submittingLabel="Salvando..."
    />
  );
}
